import React from "react";
import { Col } from "reactstrap";
import { useReactToPrint } from "react-to-print";
import { Btn } from "../../../../../AbstractElements";

export default function Invoice6Button({ contentRef }: { contentRef: React.RefObject<HTMLDivElement | null> }) {
  const handlePrint = useReactToPrint({ contentRef });
  return (
    <Col sm={12} className="text-center mb-3">
      <Btn color="primary" className="me-2" onClick={() => handlePrint()}>
        {"Print"}
      </Btn>
      <Btn color="secondary">{"Cancel"}</Btn>
    </Col>
  );
}
